module.exports = __webpack_public_path__ + "img/yqd.9424d986.png";